<template>
  <div>
    <HMModalHeader
      :title="waiver.title"
      @close="$emit('close')"
    ></HMModalHeader>
    <span
      >{{ $t('GENERAL.LABEL.CREATED') }}:
      {{ $formatDate(waiver.created) }}</span
    >
    <HMCustomContent
      :html="waiver.waiver"
      :json="waiver.waiver_new"
      class="custom-content rounded bg-lightest-gray mt-3 p-3"
    />
  </div>
</template>

<script>
export default {
  name: 'WaiverShowModal',
  props: {
    waiver: {
      type: Object,
    },
  },
};
</script>

<style scoped></style>
